import React from "react";
import styled from "styled-components";
import Summary from "./summary";
import { Row, Col } from "components/shared/layout";
import Layout from "../../shared/card-layout";

const FormsContainer = styled.div`
  width: 100%;
`;

const BusinessOverviewForm = () => (
  <FormsContainer>
    <Row xs={12}>
      <Col xs={12} lg={6}>
        <Layout title="Business Overview">
          <Summary />
        </Layout>
      </Col>
      <Col xs={12} lg={6} />
    </Row>
  </FormsContainer>
);
export default BusinessOverviewForm;
